import gsap from 'gsap';
import CustomEase from 'gsap/dist/CustomEase';
import ObjectsHolder from '../ObjectsHolder';
import { radians } from '../../../../utils/degreesAndRadians';

gsap.registerPlugin(CustomEase);

const THREE = require('three');

class WindOscillateObject3D extends ObjectsHolder {
    constructor(data, webgl, obj3D, reflection3D = null) {
        super(data, webgl, {
            obj3D, reflection3D
        });
    }

    _setup(data, stgs, webgl) {
        super._setup(data, stgs, webgl);

        this.hasInvalidate = true;
        this.hasTweens = true;
    }

    _constructView(data, webgl, stgs, factory, orientation) {
        super._constructView(data, webgl, stgs, factory, orientation);

        const { obj3D, reflection3D } = stgs;

        this.add(obj3D);

        this.obj3D = obj3D;

        let reflectionShell = null;

        if (reflection3D) {
            reflectionShell = new THREE.Group();
            reflectionShell.add(reflection3D);
        }

        // You need to inject reflectionShell instead of reflection3D. i.e. you need to substitute it
        this.reflection3D = reflection3D;
        this.reflectionShell = reflectionShell;

        this.state = {
            rotation: 0,
            rotationChanged: true
        };

        this.syncTargets = [obj3D, reflection3D];
    }

    _start() {
        const ease0 = CustomEase.create(
            'custom',
            'M0,0,C0.254,0,0.467,0.213,0.574,0.434,0.688,0.67,0.776,0.964,1,1'
        );
        const ease1 = CustomEase.create(
            'custom',
            'M0,0,C0.138,0,0.232,0.292,0.328,0.512,0.435,0.758,0.6,1,1,1'
        );
        const tl = gsap.timeline({
            repeat: -1
        });

        const onUpdate = () => {
            this.state.rotationChanged = true;
        };

        tl.to(this.state, {
            duration: 0.5,
            rotation: -2,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 0.85,
            rotation: 1.5,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 0.85,
            rotation: -0.75,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 0.65,
            rotation: 0.3,
            ease: ease0,
            onUpdate
        });

        tl.to(this.state, {
            duration: 0.75,
            rotation: -2.8,
            ease: ease1,
            onUpdate
        });

        tl.to(this.state, {
            duration: 1.4,
            rotation: 1.8,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 1,
            rotation: -0.9,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 1.15,
            rotation: 0.55,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 1.3,
            rotation: 0.275,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 2,
            rotation: 0,
            ease: 'sine.inOut',
            onUpdate
        });

        let a = -2;

        tl.to(this.state, {
            duration: 0.75,
            rotation: a,
            ease: 'sine.inOut',
            onUpdate
        });

        a *= -0.75;

        tl.to(this.state, {
            duration: 0.85,
            rotation: a,
            ease: 'sine.inOut',
            onUpdate
        });

        a *= -0.75;

        tl.to(this.state, {
            duration: 0.85,
            rotation: a,
            ease: 'sine.inOut',
            onUpdate
        });

        a *= -0.75;

        tl.to(this.state, {
            duration: 0.85,
            rotation: a,
            ease: 'sine.inOut',
            onUpdate
        });

        a *= -0.75;

        tl.to(this.state, {
            duration: 0.85,
            rotation: a,
            ease: 'sine.inOut',
            onUpdate
        });

        tl.to(this.state, {
            duration: 1,
            rotation: 0,
            ease: 'sine.inOut',
            onUpdate
        });
    }

    invalidate(t, dt) {
        super.invalidate(t, dt);

        if (this.state.rotationChanged) {
            const { rotation } = this.state;

            this.syncTargets.forEach((target) => {
                target.rotation.z = radians(rotation);
            });
        }

        this.state.rotationChanged = false;
    }
}

export default WindOscillateObject3D;
